<shared-modal>
  <!-- header -->
  <h2 slot="header">Criar agente</h2>

  <!-- body -->
  <div class="flex flex-col gap-4">
    <input placeholder="Nome" [(ngModel)]="agent.name" [disabled]="loading" />
  </div>

  <!-- footer -->
  <button
    slot="footer"
    class="secondary"
    [disabled]="loading"
    (click)="
      sharedService.closeModal(route);
      analyticsService.logEvent('admin_close_agent_modal')
    "
  >
    Cancelar
  </button>
  <button
    slot="footer"
    [disabled]="!agent.name || loading"
    (click)="save(); analyticsService.logEvent('admin_save_agent_click')"
  >
    {{ loading ? 'Salvando...' : 'Confirmar' }}
  </button>
</shared-modal>
